import { cookiesKeyNames } from '@revbox/common-fe'
import { joyrideSteps } from '@revbox/localization'

export const targets = {
    advDashboardCard: 'adv-dashboard-card',
    sidebarNavPpc: 'sidebar-nav-ppc',
    ppcSummaryBarStatus: 'ppc-summary-bar-status',
    ppcSummaryBarCredits: 'ppc-summary-bar-credits',
    ppcSummaryBarBudget: 'ppc-summary-bar-budget',
    cluster1RowTour: 'cluster-1-row-tour',
    cluster2RowTour: 'cluster-2-row-tour',
    cluster3RowTour: 'cluster-3-row-tour',
    clickOpportunityTour: 'click-opportunity-column',
    ppcBiddingRules: 'ppc-bidding-rules',
    sidebarNavAnalytics: 'sidebar-nav-analytics',
    biddingButton: 'bidding-button',
    bidModalContent: 'bid-modal-content',
    bidModalAmount: 'bid-modal-amount',
    bidModalToggle: 'bid-modal-toggle',
    bidModalPreview: 'bid-modal-preview',
    bidModalSave: 'bid-modal-save'
}

const prepareTarget = (target, isClass = false) => (isClass ? `.${target}` : `#${target}`)

export const buildSteps = language => {
    const { ppc_auctions, placing_bid } = joyrideSteps[language]
    const isClass = true
    const tours = {
        [cookiesKeyNames.tourAdvInit]: [
            { target: prepareTarget(targets.advDashboardCard), content: ppc_auctions.adv_dashboard_card, disableBeacon: true },
            {
                target: prepareTarget(targets.sidebarNavPpc),
                content: ppc_auctions.sidebar_nav_ppc,
                spotlightClicks: true,
                spotlightPadding: 0,
                disableBeacon: true,
                hideFooter: true
            },
            {
                target: prepareTarget(targets.ppcSummaryBarStatus),
                title: ppc_auctions.ppc_summary_bar.status.title,
                content: ppc_auctions.ppc_summary_bar.status.content
            },
            {
                target: prepareTarget(targets.ppcSummaryBarCredits),
                title: ppc_auctions.ppc_summary_bar.credits.title,
                content: ppc_auctions.ppc_summary_bar.credits.content
            },
            {
                target: prepareTarget(targets.ppcSummaryBarBudget),
                title: ppc_auctions.ppc_summary_bar.budget.title,
                content: ppc_auctions.ppc_summary_bar.budget.content
            },
            { target: prepareTarget(targets.cluster1RowTour, isClass), content: ppc_auctions.department, spotlightPadding: 0 },
            { target: prepareTarget(targets.cluster2RowTour, isClass), content: ppc_auctions.c1, spotlightPadding: 0 },
            { target: prepareTarget(targets.cluster3RowTour, isClass), content: ppc_auctions.c2, spotlightPadding: 0 },
            { target: prepareTarget(targets.clickOpportunityTour, isClass), content: ppc_auctions.click_opportunity, spotlightPadding: 0 },
            { target: prepareTarget(targets.ppcBiddingRules), content: ppc_auctions.ppc_bidding_rules },
            { target: prepareTarget(targets.sidebarNavAnalytics), content: ppc_auctions.sidebar_nav_analytics, spotlightPadding: 0 },
            {
                target: prepareTarget(targets.biddingButton),
                content: ppc_auctions.start_bid,
                spotlightClicks: true,
                spotlightPadding: 0,
                disableBeacon: true
            }
        ],
        [cookiesKeyNames.tourAdvBidding]: [
            {
                target: prepareTarget(targets.bidModalContent),
                content: placing_bid.bid_modal_content,
                disableBeacon: true,
                spotlightPadding: 0,
                placement: 'center'
            },
            { target: prepareTarget(targets.bidModalAmount), content: placing_bid.bid_modal_amount, spotlightPadding: 0 },
            { target: prepareTarget(targets.bidModalToggle), content: placing_bid.bid_modal_toggle, spotlightPadding: 5 },
            { target: prepareTarget(targets.bidModalPreview), content: placing_bid.bid_modal_preview, spotlightPadding: 5 },
            { target: prepareTarget(targets.bidModalSave), content: placing_bid.bid_modal_save },
            { target: prepareTarget(targets.bidModalContent), content: placing_bid.finish, spotlightPadding: 0 }
        ]
    }

    Object.keys(tours).forEach(tourKey => {
        tours[tourKey].forEach(step => {
            step.disableOverlayClose = true
            step.hideCloseButton = true
        })
    })

    return tours
}
